import type { ClinicalPerson } from '~/backend/connector-next-api/connector-next-schemas';
import type { Choice } from './ChoicePicker';

/** The people who can be chosen for a patient, as picker choices by access user id. */
export const personChoices = (
    people: readonly ClinicalPerson[] | null | undefined
): Choice[] =>
    (people ?? []).flatMap((person) =>
        person.id == null
            ? []
            : [{ value: person.id, label: person.displayName ?? person.id }]
    );
